module.exports = __webpack_public_path__ + "static/media/agreement.714ca397.png";